<style>
  ::-webkit-scrollbar {
    width: 0px;
  }
</style>

<div
  style="
    overflow-y: scroll;
    position: relative;
    height: 100vh;
    background: url('../../../../../assets/images/backgrounds/pes-background.jpg');
    background-size: cover;
  "
>
  <ngx-ui-loader
    [loaderId]="'loader02'"
    [fgsColor]="'#fd9b14'"
    [bgsColor]="'#10b7cb'"
    [bgsPosition]="'bottom-left'"
    [bgsType]="'ball-spin-clockwise'"
    [fgsPosition]="'center-center'"
    [fgsType]="'ball-spin-clockwise'"
    [logoPosition]="'center-center'"
    [overlayColor]="'rgba(40, 40, 40, 0.4)'"
    [pbColor]="'#fd9b14'"
    [pbDirection]="'ltr'"
    [textColor]="'#FFFFFF'"
    [textPosition]="'center-center'"
  ></ngx-ui-loader>
  <router-outlet></router-outlet>
  <div
    class="pl-28"
    style="
      position: fixed;
      bottom: 10px;
      left: 0;
      font-size: 20px;
      color: white;
      font-weight: bold;
      font-style: italic;
    "
    id="sashi-logo"
  >
    <a
      href="/home"
      fxLayout="row"
      fxLayoutAlign="center center"
      matTooltip="Trang chủ"
    >
      <button mat-icon-button style="color: white">
        <mat-icon>home</mat-icon></button
      >SASHI 2021</a
    >
  </div>
</div>
